import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { ReferenceGraphemeMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { MorphemeInfoPanelCaligraphyStrokesSurface } from "#morpheme-info-panel-caligraphy-strokes-surface";

/** The combined Reference page still uses descriptors; the Calligraphy tab renders the surface. */
export function useMorphemeInfoPanelCaligraphyStrokesSection({
  graphemeCard,
}: {
  graphemeCard: ReferenceGraphemeMorphemeSlice | null;
}): MorphemeInfoPanelAccordionSectionDescriptor | null {
  const [isOpen, setIsOpen] = useRouteBodyState(
    "use-morpheme-info-panel-caligraphy-strokes-section.tsx:isOpen",
    true,
  );

  if (graphemeCard === null) {
    return null;
  }

  return {
    bodyKey: "morpheme-info-caligraphy-strokes-body",
    headerKey: "morpheme-info-caligraphy-strokes-header",
    iconName: "LuPenLine",
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => (
      <MorphemeInfoPanelCaligraphyStrokesSurface className="m-2" graphemeCard={graphemeCard} />
    ),
    title: "Strokes",
  };
}
